<template>
  <ul class="no_record">
    <div class="page-status-panel">
        <div class="img-block">
            <img src="../../assets/images/icons/norecord.svg" alt />
        </div>
        <div class="details-block">
            <h2>{{$t('noRecordFound')}}</h2>
            <p>{{$t('noRecordFoundMsg')}}</p>
        </div>
        </div>
    </ul>
</template>
<script>
export default {
  name: "NoDataFound",
  props: {
    dataValue: {
      type: Object
    }
  },
  data() {
    return {
     
    };
  },
  mounted() {}
};
</script>
<style scoped>

.page-status-panel {
    width: 100%;
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.page-status-panel .img-block {
    width: 100%;
    height: 200px;
    margin-top: 40px;
}

.page-status-panel .bg_stars {
    background-image: url('../../assets/images/icons/star_ptrn.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.page-status-panel .img-block img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.page-status-panel .details-block {
    width: 100%;
    padding: 15px;
    align-self: flex-end;
}

.page-status-panel .details-block h2 {
    color: #262626;
    font-size: 1.250em;
    text-align: center;
    padding: 15px 0px 20px;
}

.page-status-panel .details-block p {
    color: #B6BBBF;
    font-size: 1em;
    line-height: 28px;
    text-align: center;
}

.page-status-panel .btn-block {
    width: 100%;
    align-self: flex-end;
    padding-bottom: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.page-status-panel .btn-block span {
    background: #FF9933;
    padding: 10px 20px;
    font-size: 1em;
    color: #fff;
    border-radius: 9px;
}

.page-status-panel .btn-block .success {
    background: #138808;
}

</style>